<script lang="ts">
	import type { Stripe } from '@stripe/stripe-js'
	import { loadStripe } from '@stripe/stripe-js'
	import { onMount } from 'svelte'

	import { browser } from '$app/environment'
	import { goto } from '$app/navigation'
	import { page } from '$app/stores'
	import Switch from '$lib/components/Common/switch.svelte'
	import environment from '$lib/environment'
	import { sentryError } from '$lib/functions/sentry'
	import { apiPostJson } from '$lib/proxy/apiProxy'
	import { account } from '$lib/stores/account/account'
	import { trialDaysRemaining, trialIsOver } from '$lib/stores/account/manager'
	import { getTrialDays, InitBoSettings } from '$lib/stores/bo_settings'
	import {
		getSuccessPath,
		setSuccessPath
	} from '$lib/stores/subscription/subscription'
    import { getSubscriptionFeatures } from '$lib/stores/subscription_features/subscription_features'
    import { getSubscriptionPlanFeatures } from '$lib/stores/subscription_plan_features/subscription_plan_features'
    import { getSubscriptionTableIdActive, getSubscriptionTableInfo } from '$lib/stores/subscription_table_info/subscriptions_table_info'
    import type { SubscriptionTableInfo } from '$lib/stores/subscription_table_info/types'
	import type { SubscriptionFeature, SubscriptionPlanFeature } from '$lib/types/subscription_types'

	import SubscribeTable from './SubscribeTable.svelte'

	export let configMode = false
	export let subscribeTableId = ''
	export let timestampTableId = 0

	//if (browser && subscribeTableId === '') subscribeTableId = getSettingsValue('subscribe_table_id')
	if (browser && subscribeTableId === '') {
		console.log('subscribeTableId 1', subscribeTableId)
		getTableIdActive()
	}

	async function getTableIdActive() {
		subscribeTableId = await getSubscriptionTableIdActive()
		console.log('subscribeTableId 2', subscribeTableId)
	}

	// const dispatch = createEventDispatcher()

	let subscriptionTableInfo: SubscriptionTableInfo[] = []
	let subscriptionPlanFeatures: SubscriptionPlanFeature[]
	let subscriptionFeatures: SubscriptionFeature[]
	let loadedTableId = ''
	// let couponId = ''
	let tableHasCoupon = false

	$: loadedTableId = timestampTableId.toString()
	$: {
		if (browser && subscribeTableId != '' && loadedTableId != subscribeTableId) {
			// load this first
			getSubscriptionFeatures().then((response) => {
				if (response) setSubscriptionFeatures(response)

				// SubscriptionTableInfo
				getSubscriptionTableInfo(subscribeTableId).then((response2) => {
					if (response2) setTableInfo(response2)
				})
				
				// SubscriptionPlanFeatures
				getSubscriptionPlanFeatures().then((response3) => {
					if (response3) setSubscriptionPlanFeatures(response3)
				})
			})
		}
	}

	let loaded = false
	// let submitting = false
	let applyCoupon = false
	let tougleDiscountOn = false
	let offerCountdown = ''
	let successPath = getSuccessPath() || '/?thankyou' // read success url
	let subTitle = 'Upgrade now for unlimited access'

	let subTitleText = ''
	let offerText = ''
	let trialText = ''

	setSuccessPath('') // clean success url

	onMount(async () => {
		await InitBoSettings()
	})

	function setSubscriptionPlanFeatures(response: SubscriptionPlanFeature[]) {
		subscriptionPlanFeatures = response
	}

	function setSubscriptionFeatures(response: SubscriptionFeature[]) {
		subscriptionFeatures = response
	}

	function setTableInfo(response: SubscriptionTableInfo[]) {
		subscriptionTableInfo = response
		if (!subscriptionTableInfo || subscriptionTableInfo.length == 0) return

		// couponId = ''
		tableHasCoupon = false
		const elemWithCoupon = subscriptionTableInfo.find((element) => element.stripe_coupon_id != '')
		if (elemWithCoupon) {
			// couponId = elemWithCoupon.stripe_coupon_id
			tableHasCoupon = true
		}
		offerText = subscriptionTableInfo[0].offer_text
		trialText = subscriptionTableInfo[0].trial_text
		subTitleText = subscriptionTableInfo[0].subtitle_text
		//
		// force regenerate sub-title
		subTitle = getSubtitle()
		//
		// if (couponId=='')
		if (!tableHasCoupon) tougleDiscountOn = false
		else if (configMode) applyCoupon = true
		//
		loadedTableId = subscribeTableId
	}

	// async function checkSubscription() {
	// 	if (!$account.stripe_subscription_id) {
	// 		return false
	// 	}
	// 	const result = await apiPostJson(`/stripe/subscription/check`)
	// 	if (result.error) {
	// 		console.error(result.error)
	// 		return false
	// 	} else {
	// 		return result.subscription
	// 	}
	// }

	let _stripe: Stripe | null = null
	async function getStripe() {
		console.log('_stripe, using stripe api key', _stripe, environment.stripeApiKey)
		if (_stripe) {
			return _stripe
		}
		_stripe = await loadStripe(environment.stripeApiKey)
		return _stripe
	}

	async function sanityChecks() {
		console.log('subscription check')
		if (!$account.registered) {
			// handleClose()
			return goto('/signup')
		}
		// const subscription = await checkSubscription()
		// if (subscription) {
		// 	console.log('sanityChecks - has suscription')
		// 	if (subscription.status === 'active') {
		// 		handleClose()
		// 		return
		// 	}
		// }
	}

	onMount(async () => {
		console.log('SubscribeDialog4.onMount')

		// If the account already subscribed goto settings.
		sanityChecks()

		// disable free trial toggle and pricing in subscribe modal for active subscribers
		if ($account.stripe_subscription_status === '') {
			console.log('$account.stripe_subscription_status', $account.stripe_subscription_status)
			applyCoupon = !trialIsOver() || getTrialDays() === 0
		}
		tougleDiscountOn = applyCoupon // tougleDiscountOn is used for the tougle on / off
		offerCountdown = Math.max(trialDaysRemaining(), 0).toString()
		subTitle = getSubtitle()

		loaded = true
	})

	function getSubtitle() {
		// let result = 'Upgrade Now for Unlimited Access'
		let result = subTitleText
		const status = $account.stripe_subscription_status

		if (status === '') {
			if (trialIsOver()) {
				result = 'Your free trial is over. Upgrade now to continue'
			} else {
				result = subTitleText
			}
		} else if (status === 'canceled') {
			result = 'Your subscription is cancelled. Pay now to continue.'
		} else if (status === 'unpaid') {
			result = 'Your subscription is unpaid. Pay now to continue.'
		} else if (status === 'incomplete_expired') {
			result = 'Your subscription is incomplete. Pay now to continue.'
		} else if (status === 'past_due') {
			result = 'Your subscription is past due. Pay now to continue.'
		}

		return result
	}

	async function handleSubscribe(event: CustomEvent) {
		// submitting = true

		const data = event.detail
		let useCuponId = ''
		// Apply cuponId if is valid. (not expired)
		if (applyCoupon) {
			useCuponId = data.coupon_id
		}

		if (configMode) {
			console.log('Stripe subscribe clicked!', data)
			alert('stripe subscribe clicked! \n ' + JSON.stringify(data, null, 2))
			return
		}

		// coupon_id: data.coupon_id
		const jsonData = await apiPostJson('/stripe/subscription/checkout/create', {
			subscription_period: data.subscription_period,
			success_path: successPath,
			cancel_path: $page.url.pathname,
			price_id: data.price_id,
			coupon_id: useCuponId
		})
		if (jsonData?.error) {
			throw new Error(jsonData.error.message)
		}
		const session_id = jsonData.session_id
		const stripe = await getStripe()
		if (!stripe) {
			const error = new Error('Could not retrieve stripe')
			sentryError(error.message)
			// console.error(error)
			return
		}
		await stripe.redirectToCheckout({
			sessionId: session_id
		})
	}

	function setTestCouponInfo(checked: boolean) {
		if (!checked) {
			applyCoupon = false
			tougleDiscountOn = false
		} else {
			applyCoupon = true
			tougleDiscountOn = true
		}
	}
</script>

{#if configMode && tableHasCoupon}
	<div class="p-3 border mb-3">
		<span class="inline-block align-middle text-base text-center">Try when the Coupon applies</span>
		<Switch
			data-test-id="config_test"
			checked={applyCoupon}
			on:input={async (e) => {
				setTestCouponInfo(e.detail.value)
			}}
		/>
	</div>
{/if}
<div class="bg-gray-100">
	<!-- Logo -->
	<div class="flex p-6">
		<div class="inline-block align-middle">
			<div class="w-18 h-18 p-1">
				<img src="/simple-logo.svg" alt="Invoicer.ai Logo" class="logo-icon" />
			</div>
		</div>
		<div class="inline-block align-middle ml-3">
			<h2 class="m-2 text-2xl leading-6 font-medium text-gray-900">Invoicer.ai</h2>
			<p data-test-id="subscribe_subtitle" class="m-2 text-md text-gray-500">{subTitle}</p>
		</div>
	</div>
	<!-- {#if (configMode || (applyCoupon && couponId!=''))} -->
	<!-- {#if (applyCoupon && couponId!='')} -->
	{#if applyCoupon && tableHasCoupon}
		<div class="p-6 flex space-x-2 items-center justify-center align-middle">
			<span class="inline-block align-middle text-base text-center">{offerText}</span>
			<!-- {#if trialText != ''} -->
			{#if tableHasCoupon}
				<Switch data-test-id="subscribe_switch" showText={false} bind:checked={tougleDiscountOn} />
				<span class="text-base text-center"> {trialText}</span>
			{/if}
		</div>
	{/if}

	<!-- {subscribeTableId} -->
	<SubscribeTable
		{configMode}
		{tougleDiscountOn}
		{subscriptionTableInfo}
		{subscriptionPlanFeatures}
		{subscriptionFeatures}
		on:subscribe={handleSubscribe}
	/>

	<!-- Offer Countdown -->
	{#if loaded && applyCoupon}
		<div class="border rounded bg-white p-4 mt-4 w-full">
			<div data-test-id="subscribe_offercountdown" class="flex w-full text-gray-500 justify-center">
				Your free trial is valid for {offerCountdown} more days. Upgrade now for unlimited access.
			</div>
		</div>
	{/if}
</div>
